<div class="home-skeleton-container" *ngIf="homePageDataSectionsSildersShimmer">
    <div class="section-skeleton-container">
        <div class="section-header-skeleton">
            <div class="section-name light-animate-shimmer"></div>
        </div>
        <div class="section-ad-container">
            <div class="light-animate-shimmer large-ad-shimmer"></div>
            <div class="small-ad-container">
                <div class="light-animate-shimmer small-ad-shimmer"></div>
                <div class="light-animate-shimmer small-ad-shimmer"></div>
            </div>
            <div class="small-ad-container">
                <div class="light-animate-shimmer small-ad-shimmer"></div>
                <div class="light-animate-shimmer small-ad-shimmer"></div>
            </div>
        </div>
        <div class="skeleton-container">
            <div class="skeleton-list-container" *ngFor="let item of fakeArray">
                <div class="skeleton-container-inside">
                    <div class="light-animate-shimmer image-shimmer"></div>
                    <div
                        class="light-animate-shimmer description-shimmer"
                    ></div>
                    <div class="light-animate-shimmer price-shimmer"></div>
                    <div class="light-animate-shimmer price-shimmer"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="homePageDataSectionsSilders?.length" class="container">
    <div *ngFor="let objectList of homePageDataSectionsSilders; let indexParentSection = index" class="">
        <ng-container
            *ngIf="
                objectList &&
                (objectList?.products?.length > 0 ||
                    objectList?.images?.length > 0)
            "
        >
            <div class="title-box">
                <h5
                    style="font-size: 1.4rem !important;"
                    *ngIf="objectList?.show_title"
                    class="lable title"
                    [ngClass]="{
                        'border-background-none pt-2' : environmentVariables?.ENABLE_REMOVE_HOME_SECTION_BORDER , 
                        'p-3' : !environmentVariables?.ENABLE_REMOVE_HOME_SECTION_BORDER 
                    }"
                >
                    {{
                        lang == "en" ? objectList?.name_en : objectList?.name_ar
                    }}
                </h5>
                <div
                    *ngIf="objectList?.products?.length > 0"
                    class="block-title mb-2 mt-3"
                >
                    <div
                        class="flex-end"
                        i18n="
                            newProductHeader|newProductHeader@@newProductHeader"
                    >
                        <p
                            (click)="bannerRouting(objectList, indexParentSection)"
                            class="text-inverse mb-0 show-more-btn"
                        >
                            {{ "home_Page.viewAll" | translate }}
                        </p>
                    </div>
                </div>
            </div>

            <div
                class="products-group mb-3"
                *ngIf="objectList.image_type === 1"
                [ngClass]="{
                    'products-group-ar': lang === 'ar',
                    'no-title': !objectList?.show_title,
                    'border-background-none' : environmentVariables?.ENABLE_REMOVE_HOME_SECTION_BORDER
                }"
            >
                <div
                    *ngIf="objectList?.have_products"
                    class="shop-card-wrapper section-gap pt-0 pb-5 grid-card-wrapper tab-sldier-v2"
                    style="padding-bottom: 0rem !important"
                >
                    <mat-toolbar
                        class="section-title-toolbar grid-toolbar"
                        style="height: 160px; background-color: transparent"
                    >
                    </mat-toolbar>

                    <div
                        *ngIf="objectList?.products?.length"
                        [ngClass]="{'p-2' : !environmentVariables?.ENABLE_REMOVE_HOME_SECTION_BORDER }"
                        style="margin-top: -150px"
                    >
                        <div class="swiper-container">
                            <swiper
                                [config]="bigSwiperConfig"
                                class="mySwiper"
                                #newSwiper
                            >
                                <ng-template
                                    swiperSlide
                                    *ngFor="let product of objectList?.products"
                                    class="swiper-slide"
                                >
                                    <app-updated-product-card
                                        [viewLocation]="'home'"
                                        (addToCart)="addToCart($event)"
                                        *ngIf="product"
                                        [product]="product"
                                    >
                                    </app-updated-product-card>
                                </ng-template>
                            </swiper>
                        </div>
                    </div>
                </div>
            </div>

            <div
                *ngIf="objectList.image_type === 2"
                [ngClass]="{
                    'products-group-ar': lang === 'ar',
                    'no-title': !objectList?.show_title,
                    'products-group mb-3': objectList?.products,
                    'border-background-none' : environmentVariables?.ENABLE_REMOVE_HOME_SECTION_BORDER
                }"
            >
                <div
                    [ngStyle]="{
                        direction: lang === 'ar' ? 'rtl' : 'ltr'
                    }"
                    class="banners-container section-gap pt-0"
                    style="
                        align-items: center;
                        flex-direction: column;
                    "
                >
                    <div
                        class="banner-second-container mt-2"
                        fxLayoutAlign="start center"
                        fxFlex.gt-sm="100"
                        fxLayout="column"
                        fxLayout.gt-sm="row"
                        [ngClass]="{
                            'p-0':
                                !objectList?.products ||
                                objectList?.products?.length == 0,
                            '': objectList?.products?.length > 0
                        }"
                    >
                        <div
                            (click)="bannerRouting(objectList.images[0] , indexParentSection)"
                            [ngClass]="
                                objectList.images[0].type != 0
                                    ? 'pointer'
                                    : 'no-envent'
                            "
                            class="imageAdsContainer d-flex justify-center"
                        >
                            <img  loading="lazy" 
                                class="responsive-image mob-view"
                                [src]="
                                    lang == 'en'
                                        ? objectList.images[0].image_en
                                        : objectList.images[0].image_ar
                                "
                                 alt="mobile image"
                                onError="this.src='./../../../../assets/images/section/400x400.png';"
                            />
                            <img  loading="lazy" 
                                class="rev-responsive-image web-view"
                                [ngClass]="{'position-relative bottom8': environmentVariables?.LABEL_SIZE !== 'large'}"
                                [src]="
                                    lang == 'en'
                                        ? objectList.images[0].image_web_en
                                        : objectList.images[0].image_web_ar
                                "
                               alt="mobile image"
                                onError="this.src='./../../../../assets/images/section/400x400.png';"
                            />
                        </div>
                        <div
                            class="margin-bannar-custom"
                            style="align-items: flex-end"
                        >
                            <div
                                *ngIf="objectList?.products?.length"
                                style="max-width: 100%; align-items: center"
                            >
                                <div class="swiper-container">
                                    <swiper
                                        [config]="smallSwiperConfig"
                                        class="mySwiper"
                                        #newSwiperLowSlides
                                    >
                                        <ng-template
                                            swiperSlide
                                            *ngFor="
                                                let product of objectList?.products
                                            "
                                            class="swiper-slide"
                                        >
                                            <app-updated-product-card
                                                [viewLocation]="'home'"
                                                (addToCart)="addToCart($event)"
                                                *ngIf="product"
                                                [product]="product"
                                            >
                                            </app-updated-product-card>
                                        </ng-template>
                                    </swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                *ngIf="objectList.image_type === 3"
                [ngClass]="{
                    'products-group-ar': lang === 'ar',
                    'no-title': !objectList?.show_title,
                    'products-group mb-3':
                        objectList?.products && objectList?.products?.length > 0,
                        'border-background-none' : environmentVariables?.ENABLE_REMOVE_HOME_SECTION_BORDER
                }"
            >
                <app-banners [banners]="objectList?.images"> </app-banners>
                <div
                    *ngIf="objectList?.have_products"
                    class="shop-card-wrapper section-gap pt-0 pb-5 grid-card-wrapper tab-sldier-v2"
                    style="padding-bottom: 0rem !important"
                >
                    <mat-toolbar
                        class="section-title-toolbar grid-toolbar"
                        style="height: 180px; background-color: transparent"
                    >
                    </mat-toolbar>
                    <div
                        *ngIf="
                            objectList?.products?.length &&
                            objectList?.type != 1
                        "
                        class=""
                        style="margin-top: -150px"
                    >
                        <div class="swiper-container">
                            <swiper
                                [config]="bigSwiperConfig"
                                class="mySwiper"
                                #newSwiper
                            >
                                <ng-template
                                    swiperSlide
                                    *ngFor="let product of objectList?.products"
                                    class="swiper-slide"
                                >
                                    <app-updated-product-card
                                        [viewLocation]="'home'"
                                        (addToCart)="addToCart($event)"
                                        *ngIf="product"
                                        [product]="product"
                                    >
                                    </app-updated-product-card>
                                </ng-template>
                            </swiper>
                        </div>
                    </div>
                </div>
            </div>

            <div
                *ngIf="
                    objectList.image_type > 3 && objectList?.images?.length > 0
                "
                [ngClass]="{
                    'products-group mb-2': objectList?.products?.length > 0,
                    'no-title': !objectList?.show_title,
                    'border-background-none' : environmentVariables?.ENABLE_REMOVE_HOME_SECTION_BORDER
                }"
            >
                <div
                    *ngIf="
                        objectList.image_type > 3 && objectList.image_type != 8
                    "
                    [ngClass]="{
                        'd-md-flex d-none':
                            objectList.image_type == 7 ||
                            objectList.image_type == 9,
                        'd-flex': !(objectList.image_type == 7 ||
                            objectList.image_type == 9)
                    }"
                    class="multi-imgs-area mb-3"
                >
                    <ng-container
                        *ngFor="let img of objectList?.images; let i = index"
                    >
                        <div
                            class="single-img"
                            [ngClass]="{
                              'pointer': img.type !== 0,
                              'no-event': img.type === 0,
                              'border-0' : environmentVariables?.   ENABLE_REMOVE_BORDER_FROM_ALL_SECTIONS
                            }"
                            
                            (click)="bannerRouting(img , indexParentSection,i)"
                        >
                            <img  loading="lazy" 
                                src="{{
                                    lang != 'en'
                                        ? img?.image_web_ar
                                        : img?.image_web_en
                                }}"
                                class="web-view"
                                onError="this.src='./../../../../assets/images/section/600x160.png';"
                                   alt="web image"
                            />
                            <img  loading="lazy" 
                                src="{{
                                    lang != 'en' ? img?.image_ar : img?.image_en
                                }}"
                                class="mob-view"
                                onError="this.src='./../../../../assets/images/section/600x160.png';"
                                   alt="mobile image"
                            />
                        </div>
                        <div
                            *ngIf="i + 1 < objectList?.images.length"
                            class="devider"
                        ></div>
                    </ng-container>
                </div>
                <div
                    *ngIf="
                        objectList.image_type == 7 || objectList.image_type == 9
                    "
                    class="multi-imgs-area d-md-none d-flex"
                >
                    <ng-container
                        *ngFor="let img of objectList?.images; let i = index"
                    >
                        <div
                            *ngIf="
                                (i < 2 && objectList.image_type == 7) ||
                                (i < 3 && objectList.image_type == 9)
                            "
                            class="single-img"
                            [ngClass]="{
                              'pointer': img.type !== 0,
                              'no-event': img.type === 0,
                              'border-0' : environmentVariables?.   ENABLE_REMOVE_BORDER_FROM_ALL_SECTIONS
                            }"
                            (click)="bannerRouting(img, indexParentSection,i)"
                        >
                            <img  loading="lazy" 
                                src="{{
                                    lang != 'en'
                                        ? img?.image_web_ar
                                        : img?.image_web_en
                                }}"
                                class="web-view"
                                onError="this.src='./../../../../assets/images/section/600x300.png';"
                                   alt="web image"
                            />
                            <img  loading="lazy" 
                                src="{{
                                    lang != 'en' ? img?.image_ar : img?.image_en
                                }}"
                                class="mob-view"
                                onError="this.src='./../../../../assets/images/section/600x300.png';"
                                   alt="mobile image"
                            />
                        </div>
                        <div
                            *ngIf="
                                (i == 0 && objectList.image_type == 7) ||
                                (i == 0 && objectList.image_type == 9) ||
                                (i == 1 && objectList.image_type == 9)
                            "
                            class="devider"
                        ></div>
                    </ng-container>
                </div>
                <div
                    *ngIf="
                        objectList.image_type == 7 || objectList.image_type == 9
                    "
                    class="multi-imgs-area d-md-none d-flex mb-3"
                >
                    <ng-container
                        *ngFor="let img of objectList?.images; let i = index"
                    >
                        <div
                            *ngIf="
                                (i > 1 && objectList.image_type == 7) ||
                                (i > 2 && objectList.image_type == 9)
                            "
                            class="single-img"
                            [ngClass]="{
                              'pointer': img.type !== 0,
                              'no-event': img.type === 0,
                              'border-0' : environmentVariables?.   ENABLE_REMOVE_BORDER_FROM_ALL_SECTIONS
                            }"
                            (click)="bannerRouting(img,indexParentSection, i)"
                        >
                            <img  loading="lazy" 
                                src="{{
                                    lang != 'en'
                                        ? img?.image_web_ar
                                        : img?.image_web_en
                                }}"
                                class="web-view"
                                onError="this.src='./../../../../assets/images/section/600x300.png';"
                                   alt="web image"
                            />
                            <img  loading="lazy" 
                                src="{{
                                    lang != 'en' ? img?.image_ar : img?.image_en
                                }}"
                                class="mob-view"
                                onError="this.src='./../../../../assets/images/section/600x300.png';"
                                   alt="mobile image"
                            />
                        </div>
                        <div
                            *ngIf="
                                (i == 2 && objectList.image_type == 7) ||
                                (i == 3 && objectList.image_type == 9) ||
                                (i == 4 && objectList.image_type == 9)
                            "
                            class="devider"
                        ></div>
                    </ng-container>
                </div>
                <div *ngIf="objectList.image_type == 8" class="multi-imgs-area d-flex mb-5">
                    <ng-container
                        *ngFor="let img of objectList?.images; let i = index"
                    >
                        <div
                            *ngIf="i < 3"
                            class="single-img"
                            [ngClass]="{
                              'pointer': img.type !== 0,
                              'no-event': img.type === 0,
                              'border-0' : environmentVariables?.   ENABLE_REMOVE_BORDER_FROM_ALL_SECTIONS
                            }"
                            (click)="bannerRouting(img,indexParentSection, i)"
                        >
                            <img  loading="lazy" 
                                src="{{
                                    lang != 'en'
                                        ? img?.image_web_ar
                                        : img?.image_web_en
                                }}"
                                class="web-view"
                                onError="this.src='./../../../../assets/images/section/600x160.png';"
                                   alt="web image"
                            />
                            <img  loading="lazy" 
                                src="{{
                                    lang != 'en' ? img?.image_ar : img?.image_en
                                }}"
                                class="mob-view"
                                onError="this.src='./../../../../assets/images/section/600x160.png';"
                                   alt="mobile image"
                            />
                        </div>
                        <div *ngIf="i < 2" class="devider"></div>
                    </ng-container>
                </div>
                <div *ngIf="objectList.image_type == 8" class="multi-imgs-area d-flex mb-5">
                    <ng-container
                        *ngFor="let img of objectList?.images; let i = index"
                    >
                        <div
                            *ngIf="i > 2"
                            class="single-img"
                            [ngClass]="{
                              'pointer': img.type !== 0,
                              'no-event': img.type === 0,
                              'border-0' : environmentVariables?.   ENABLE_REMOVE_BORDER_FROM_ALL_SECTIONS
                            }"
                            (click)="bannerRouting(img,indexParentSection, i)"
                        >
                            <img  loading="lazy" 
                                src="{{
                                    lang != 'en'
                                        ? img?.image_web_ar
                                        : img?.image_web_en
                                }}"
                                class="web-view"
                                onError="this.src='./../../../../assets/images/section/600x160.png';"
                                   alt="web image"
                            />
                            <img  loading="lazy" 
                                src="{{
                                    lang != 'en' ? img?.image_ar : img?.image_en
                                }}"
                                class="mob-view"
                                onError="this.src='./../../../../assets/images/section/600x160.png';"
                                   alt="mobile image"
                            />
                        </div>
                        <div *ngIf="i == 3" class="devider"></div>
                    </ng-container>
                </div>
                <div
                    *ngIf="
                        objectList?.products?.length > 0 &&
                        objectList?.image_type > 3
                    "
                    class="products-area"
                >
                    <div *ngIf="objectList?.products?.length" class="">
                        <div class="swiper-container">
                            <swiper
                                [config]="bigSwiperConfig"
                                class="mySwiper"
                                #newSwiper
                            >
                                <ng-template
                                    swiperSlide
                                    *ngFor="let product of objectList?.products"
                                    class="swiper-slide"
                                >
                                    <app-updated-product-card
                                        [viewLocation]="'home'"
                                        (addToCart)="addToCart($event)"
                                        *ngIf="product"
                                        [product]="product"
                                    >
                                    </app-updated-product-card>
                                </ng-template>
                            </swiper>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
